/**
 * This is intended to patch cookie getters and setters in iOS to enable storage of 3rd party cookies.
 * After patching, cookies are stored in local storage instead of a normal cookie storage.
 *
 * Required for correct operation of DataDog. https://github.com/DataDog/browser-sdk/issues/480
 */
const cookieDescriptor = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');

const get = (): string =>
  Object.keys(localStorage)
    .filter((key) => key.startsWith('cookie-'))
    .map((key) => ({
      key,
      cookie: JSON.parse(localStorage.getItem(key)),
    }))
    .filter(({ key, cookie }) => {
      if (cookie.expiry && new Date(cookie.expiry) < new Date()) {
        localStorage.removeItem(key);
        return false;
      }
      return true;
    })
    .map(({ key, cookie }) => `${key.replace('cookie-', '')}=${cookie.value}`)
    .join('; ');

const set = (cookie: string): void => {
  const regex = /([^=;]*)\s*=\s*([^;]*);(.*expires=([^;]+);)?/;
  const matches = regex.exec(cookie);
  cookieDescriptor.set.call(document, cookie);
  localStorage.setItem(`cookie-${matches[1]}`, JSON.stringify({ value: matches[2], expiry: matches[4] }));
};

export const patchCookie = (): void => {
  if (cookieDescriptor && cookieDescriptor.configurable) {
    Object.defineProperty(document, 'cookie', { get, set });
  }
};
